import AbstractGuestlistDetailsPageController from './abstract-details-controller';
import askForLeavingWithoutSavingChanges
    from '../../../../../modules/core/helpers/routing/ask-for-leaving-without-saving-changes';
import guestlistEditAlertHandler from '../../../../../modules/guestlists/helpers/guestlist-edit-alert-handler';

export default class GuestlistLandingpageSettingsPageController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);

        askForLeavingWithoutSavingChanges(this);

        this.angularState = this.injector.get('$state');
        this.depositService = this.injector.get('Deposit');
        this.navService = this.injector.get('NavService');

        this.editorView = '';
        this.model = {};
        this.contactCustomFieldData = [];
    }

    allowExternalRouting() {
        this.allowRoute = true;
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();

        this.injector.get('$timeout')(() => {
            this.editorView = this.stateParams.editorView ? this.stateParams.editorView : 'general';
            this.scope.$applyAsync();
        }, 300);
    }

    onModelUpdate(newData) {
        this.model = _.cloneDeep(newData);
    }

    onContactCustomFieldUpdate(newFieldDefinitions) {
        this.contactCustomFieldData = _.cloneDeep(newFieldDefinitions);
    }

    discardChanges() {
        this.navService.setSideNavCustoms([]);
        this._loadGuestlist();
    }

    save(form) {
        if (!form.$valid) {
            return;
        }
        this.submitting = true;
        this.api
            .put(
                `guestlists/${this.guestlist.id}`,
                this.model,
                {
                    headers: {
                        'x-festzelt-os-guestlist-version-hash': this.guestlist.version_hash
                    }
                }
            )
            .then(() => {
                this.injector.get('Setting').updateCompany({
                    ...this.injector.get('Users').state.company,
                    ...this.contactCustomFieldData
                });
                return this._handleUpdateSuccess();
            })
            .catch((e) => {
                return guestlistEditAlertHandler(this.injector, e)
                    .catch((e) => {
                        this.alert.handle(e);
                    })
                    .finally(() => {
                        return this._handleUpdateSuccess();
                    });
            });
    }

    _handleUpdateSuccess() {
        this.navHelper.updateEventInformation();
        this.alert.success('Success', 'Changes have been saved');
        this.submitting = false;
        return this._loadGuestlist();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/lp-settings-controller.js